import axios, { AxiosRequestConfig } from 'axios';
import qs from 'qs';

import { AxiosServiceResponse, PagedList } from 'interfaces/general';

import { BaseParams } from './geography';
import { IParamsFilter } from './catalog';

const instance = axios.create({
  baseURL: `${process.env.CLIENTS_SERVICE_ENDPOINT}/api/v1`,
  headers: {
    // SE ELIMINARIA CUANDO SE TENGA QA ESTABLE API KEY
    // 'Api-key': process.env.REQUEST_HEADER_API_KEY,
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
});

/* REQUESTS */

export interface ResponseTimeRequest {
  day: number;
  hour: number;
  minutes: number;
}
export interface CostRequest {
  amount: number;
  currencyId: number;
  priceTypeId: number;
}

export interface SaveServiceParams {
  clientId?: number;
  name?: string;
  description?: string;
  startDate?: Date | string;
  endDate?: Date | string;
  businessId?: number;
}

export interface SaveServiceResponse {
  serviceId: number;
  createdDateTime: Date | string;
}

export interface DeleteServiceResponse {
  serviceId: number;
  updateDatetime?: Date | string | null;
}

export interface ServiceSearchRequest {
  pageNumber?: number;
  pageSize?: number;
  orderColumn?: string;
  descending?: boolean;
  isExport?: boolean;
}

/* RESPONSES */
export interface Client {
  id: number;
  name: string;
  clientName: string;
  countryId: number;
  contryName: string;
  projectName: string;
  projectId: number;
  blobStorageUrlPath: string;
}

export interface ClientJobCategory {
  [x: string]: any;
  id: number;
  name: string;
  hasFrequentFailure?: boolean;
}

export interface ClientJobSubCategory {
  id: number;
  name: string;
  hasFrequentFailure: boolean;
  requireServiceProduct?: boolean;
}

export interface ClientLocationDetail {
  id: number;
  name: string;
  description: string;
  addressId: number;
  addressFull: string;
  postalCode: string;
  localityName: string;
  hasTowers: boolean;
  municipalityName: string;
  countryStateName: string;
  latitude: string;
  longitude: string;
  streetNumber: number;
  apartmentNumber: number;
  areaCode?: number;
  phoneNumber?: number;
  priorityName?: string;
  regionName?: string;
  additionalInfo?: string;
}
export interface ClientLocationItem {
  id: number;
  value: string;
}
export interface CostOption {
  amount: string;
  currencyId: number;
  paymentTypeId: number;
}
export interface ResponseTime {
  days: number;
  hours: number;
  minutes: number;
}
export interface GetAttentionTimeResponse {
  weekDayId: 1 | 2 | 3 | 4 | 5 | 6 | 0;
  weekDayName: string;
  initTime: string;
  endTime: string;
}
export interface ClientService {
  id?: number;
  name?: string;
  clientId?: number;
  operationTypeId?: number;
  operationTypeName?: string;
  serviceTypeId?: number;
  serviceTypeName?: string;
  requireServiceProduct?: boolean;
}

export interface ServiceConfigured {
  serviceId: number;
  updatedDateTime: Date | string;
}

export interface ServiceSupply {
  id: number;
  name: string;
  unitMeasurementId?: number;
  unitMeasurementName?: number;
  cost: number;
  currencyId: number;
  currencyName?: string;
  enabled: boolean;
  checked: boolean;
}

export interface ServiceSupplyPayload extends IParamsFilter {
  serviceId: number;
}

export interface ConfigureServiceSuppliesPayload {
  serviceId: number;
  ticketStatusId: number;
  enabled: boolean;
}

export interface ServiceType {
  id: number;
  name: string;
  hasFrequentFailure?: boolean;
}

export interface ServiceSearched {
  id: number;
  serviceId: number;
  clientId: number;
  serviceName: string;
  longDescription: string;
  priorityId: number;
  priorityName: string;
  cost: CostOption;
  responseTime: ResponseTime;
  serviceTypeId: number;
  serviceTypeName: string;
  serviceSchedule: GetAttentionTimeResponse[];
  jobCategoryName?: string;
  enabled?: boolean;
  name?: string;
}

export interface Service {
  id: number;
  name: string;
  description: string;
  responseTimes: [];
  serviceTypeId: number;
  serviceTypeName: string;
  priorityName: string;
  operationTypeName?: string;
  enabled: boolean;
  isEditable: boolean;
  currencyId: number;
  currencyName: string;
  paymentTypeId: number;
  paymentTypeName?: string;
  serviceId?: number;
  serviceName?: string;
  cost: number;
}

export interface ServiceSearchParams {
  clientId?: number;
  serviceIds?: number[];
  serviceName?: string;
  serviceDescription?: string;
  serviceResponseTimeDays?: number;
  serviceResponseTimeHours?: number;
  serviceResponseTimeMinutes?: number;
  serviceTypesIds?: number[];
  isEnabled?: boolean | number;
  onlyActiveTickets?: boolean;
  pageNumber?: number;
  pageSize?: number;
  orderColumn?: string;
  descending?: boolean;
  isExport?: boolean;
}

export interface ServiceSearchResponse {
  id: number;
  name: string;
  description: string;
  responseTime?: ResponseTime;
  serviceTypeName?: string;
  priorityName?: string;
  workFlowServiceTypeName?: string;
  operationTypeName?: string;
  enabled?: boolean;
  isEditable?: true;
}

export interface Priority {
  id: number;
  name: string;
}

export interface OperationType {
  id: number;
  name: string;
  enabled?: boolean;
}

export interface ServiceDetail {
  serviceId: number;
  serviceName: string;
  serviceDescription: string | null;
  startDate: Date | string;
  endDate: Date | string;
  estimatedDuration: number;
  clientId: number;
  clientName: string;
  longDescription: string;
  business: number | null;
  priority: Priority;
  serviceType: ServiceType;
  operationType: OperationType;
  responseTime: ResponseTime;
  cost: CostOption;
  enabled: boolean;
  schedule: null;
}

export interface ClientCountry {
  countryId: number;
  countryName: string;
}

export interface Project {
  id: number;
  name: string;
}

export interface AdminClientDetail {
  id: number;
  name: string;
  nameUI: string;
  description: string;
  clientCountries: ClientCountry[];
  project: Project;
  classificationId: number;
  clasificationName: string;
  blobStorageUrlPath: string;
  enabled: boolean;
  createdDateTime: Date;
}

export interface ConfigureServiceRequest {
  userId?: number;
  serviceId?: number;
  priorityId?: number;
  serviceTypeId?: number;
  responseTime?: ResponseTime;
  cost?: CostOption;
}

// ConfigureJobScheduleRequest

export interface JobDay {
  weekDay: number;
  initTime: string;
  endTime: string;
}
export interface ConfigureJobScheduleRequest {
  serviceId: number;
  startDate: Date;
  endDate: Date;
  systemUserIds: number[];
  jobDays: JobDay[];
}

// Configure Attentions Hours

export interface GetAttentionTimeRequest {
  serviceId: number;
  jobDays: JobDay[];
}
export interface MinimalEvidenceRequest {
  serviceId: number;
  minimumEvidenceQuantity: number | string;
}

export interface ConfigureIndicatorStatesRequest {
  indicatorStateId?: 1 | 2 | 3;
  minPercentage: number;
  maxPercentage: number;
}

export interface ConfigureWorkZonesRequest {
  postalCodeId: number[];
  responsibleId: number[];
}

export interface ResponsiblesResponse {
  id?: number;
  responsibleId: number;
  userId: number;
  responsibleFullName: string;
}

export interface Responsible {
  id: number;
  name: string;
  responsibleTypeId?: number;
  responsibleTypeName?: string;
  enabled: boolean;
}

export interface OperationTypeRequest {
  serviceId: number;
  operationTypeId: number;
}

export interface ConfigureServiceEvidencesResquest {
  serviceId: number;
  minimumEvidenceCount: number;
  items: {
    name: string;
    isRequired: boolean;
    itemOrder: number;
    enabled?: boolean;
  }[];
}

export interface ConfigureServiceEvidencesDetail {
  name: string;
  isRequired: boolean;
  itemOrder: number;
  enabled: boolean;
  serviceId?: number;
}

export interface ServiceConfigMinEvidence {
  key: string;
  value: string;
  unlimited?: boolean;
}

export interface AllClientRequest {
  clientId?: number | null;
  searhText?: string | null;
  countryId?: number | null;
  enabled?: boolean;
  pageNumber?: number;
  pageSize?: number;
  orderColumn?: string;
  descending?: boolean;
  isExport?: boolean;
}

export interface AllClientResponse {
  clientId: number;
  name: string;
  description: string;
  classificationId?: number;
  clasificationName?: string;
  countryId?: number;
  countryName?: string;
  enabled: boolean;
  createdDateTime?: Date;
  isDeleted?: boolean;
  blobStorageUrlPath: string;
  projectId: number;
  projectName: string;
  priorities: Priority[];
}

export type GetAllClientWithoutPag = {
  id: number;
  name: string;
  projectName: string;
  projectId: number;
  countryId: number;
  countryName: string;
};

export interface CreateClientRequest {
  name: string;
  description: string;
  priorityIds?: number[];
  projectId?: number;
  watermark: CreateWaterMarkRequest;
}

export interface GetClientsInfoByID {
  id: number;
  name: string;
  nameUI: string;
  description: string;
  clientCountries: ClientCountry[];
  classificationId: number;
  clasificationName: string;
  blobStorageUrlPath: string;
  enabled: boolean;
  createdDateTime: Date;
  project: Priority;
}

export interface EditClientsInfo {
  clientId: number;
  description: string;
  enabled: boolean;
  name: string;
  priorityIds: number[];
  projectId: number;
}

export interface ServiceGetByIdResponse {
  serviceId: number;
  serviceName: string;
  serviceDescription: string;
  startDate: Date | string;
  endDate: Date | string;
  estimatedDuration?: number;
  clientId: number;
  clientName: string;
  longDescription?: string;
  business?: string;
  priority?: Priority;
  serviceType?: ServiceType;
  operationType?: OperationType;
  responseTime?: ResponseTime;
  cost?: CostOption;
  enabled?: boolean;
  schedule?: any;
}

export interface WorkFlowRelationship {
  originStatusId: string;
  destinyStatusId: string;
  bidirectional: boolean;
  xcoordinate: number;
  ycoordinate: number;
}
export interface WorkFlowRequest {
  serviceId: number;
  workFlowRelationships: WorkFlowRelationship[];
}

export interface WorkFlowResponse {
  serviceId: number;
  workFlowId: number;
  message: string;
}
export interface IProjectResponse {
  id: number;
  name: string;
  partnerId: number;
  partnerName: string;
}

export interface Status {
  id: number;
  value: string;
}
export interface Step {
  originStatus: Status;
  destinyStatus: Status;
  bidirectional: boolean;
  xcoordinate: number;
  ycoordinate: number;
}

export interface GetWorkFLowResponse {
  workFlowId: number;
  serviceId: number;
  steps: Step[];
}

export interface ClientPrioritiesByClientRequest {
  clientIds?: number[];
  getAll?: boolean;
  pageNumber?: number;
  pageSize?: number;
  orderColumn?: string;
  descending?: boolean;
  enabled?: boolean;
}

export interface ClientPrioritiesByClient {
  clientId: number;
  clientName: string;
  enabled: boolean;
  priorityId: number;
  priorityName: string;
}

export interface CountryStatesByClientRequest extends BaseParams {
  clientId: number;
  enabled?: boolean;
}

export interface CountryStatesByClient {
  clientId: number;
  countryStateId: number;
  countryStateName: string;
  countryRegionId: number;
  countryRegionName: string;
  enabled: boolean;
}

export interface UpdateStatesByClientRequest {
  clientId: number;
  countryStateIds: number[];
}

export interface UpdateStatesByClientResponse {
  clientId: number;
  message: string;
}

export interface ServiceTypeListItem {
  serviceTypeId: number;
  serviceTypeName: string;
  ticketFlowId?: number;
  ticketFlowName?: string;
}

export interface AssignClientServiceTypesRequest {
  clientId: number;
  clientServiceTypeList: ServiceTypeListItem[];
}

export interface UpdateService {
  serviceId?: number;
  name?: string;
  description?: string;
  serviceTypeId?: number;
  enabled?: boolean;
  paymentTypeId?: number;
  currencyId?: number;
  clientId?: number;
}

export interface GeneralSearchRequest extends BaseParams {
  clientId: number;
}

export interface WorkFlowItem {
  id: number;
  name: string;
  clientId: number;
  clientName: string;
  workFlowTypeId: number;
  workFlowTypeName: string;
  enabled: boolean;
  unlimited: boolean;
  maximumValue: number;
}

export interface CreateWorkFlowRequest {
  name: string;
  workFlowTypeId: number;
  clientId: number;
  unlimited: boolean;
  maximumValue: number;
}

export interface UpdateWorkFlowRequest extends CreateWorkFlowRequest {
  id: number;
  enabled: boolean;
}

export interface WorkFlowStagesItem {
  clientId?: number;
  clientName?: string;
  stageId?: number;
  stageName?: string;
  workFlowId?: number;
  workFlowName?: string;
  itemOrder?: number;
  enabled?: boolean;
  isInitial?: boolean;
  isFinal?: boolean;
  steps?: WorkForceStep[];
  previousStages?: PreviousStage[];
}

export interface PreviousStage {
  stageId?: number;
  stageName?: string;
  isRequired?: boolean;
}

export interface WorkForceStep {
  serviceId?: number;
  serviceName?: string;
  serviceTypeId?: number;
  serviceTypeName?: string;
}

export interface CreateWorkFlowStages {
  clientId: number;
  name: string;
  workFlowId: number;
  serviceId: number;
}

export interface EditWorkFlowStages {
  clientId: number;
  name: string;
  stageId: number;
  serviceId: number;
  enabled: boolean;
}

export interface WorkFlow {
  id: number;
  name: string;
  clientId: number;
  clientName: null | string;
  workFlowTypeId: number;
  workFlowTypeName: string;
  enabled: boolean;
}

export interface TicketFlowItem {
  id: number;
  name: string;
  enabled: boolean;
  base: boolean;
}

export interface ParamsTicketFlow {
  enabled?: boolean;
  pageNumber?: number;
  pageSize?: number;
  orderColumn?: string;
  descending?: boolean;
  text?: string;
  isExport?: boolean;
}

export interface AlStatus {
  id: number;
  description: string;
  enabled: boolean;
  isBase?: boolean;
}

export interface Edge {
  initialStatus: AlStatus;
  finalStatus: AlStatus | null;
  isInitialStatus: boolean | null;
  enabled: boolean | null;
  xcoordinate: number | null;
  ycoordinate: number | null;
  hideForSelection: boolean | null;
  onlyForIncident: boolean | null;
}

export interface TicketFlowById {
  createdDateTime: Date;
  edges: Edge[];
  historical: null;
  id: number;
  name: string;
  enabled: boolean;
}

export interface TicketFlowEdit {
  ticketFlowId?: number;
  name?: string;
  enabled?: boolean;
  edges?: Edge[];
}

export interface AsociateTicketFlowPayload {
  ticketFlowId: number;
  serviceTypeId?: number;
}

export interface CreateStateFlowPayload {
  initialStatusId: number;
  finalStatusId: number;
  isInitialStatus: boolean;
  xcoordinate: null;
  ycoordinate: null;
  onlyForIncident: boolean;
  hideForSelection: null;
}

export interface CreateEditEdgePayload {
  finalStatusId: number;
  initialStatusId: number;
  isInitialStatus: boolean;
  onlyForIncident?: boolean;
}

export interface CreateTicketFlowPayload {
  name: string;
  edges: CreateEditEdgePayload[];
}

export interface EditTicketFlowPayload {
  name: string;
  edges: CreateEditEdgePayload[];
  ticketFlowId: number;
  enabled: boolean;
}

export interface CreateServiceResponseTimes {
  serviceId?: number;
  priorityId?: number;
  attentionHours?: number;
  expireHours?: number;
  cost?: number;
}

export interface UpdateServiceResponseTimes {
  responseTimeId?: number;
  serviceId?: number;
  priorityId?: number;
  attentionHours?: number;
  expireHours?: number;
  cost?: number;
}

export interface IServiceResponseTimes {
  responseTimeId?: number;
  priorityId?: number;
  attentionHours?: number;
  expireHours?: number;
  cost?: number;
  priorityName: string;
}

export interface ServiceProduct {
  serviceId?: number;
  ticketStatusId?: number;
  amount?: number;
  enabled?: boolean;
}

export interface ServiceAutomaticClosing {
  serviceId?: number;
  originStatusId?: number;
  destinationStatusId?: number;
  finalStatusId?: number;
  days?: number | string;
  enabled: boolean;
}

export interface ServiceMaximunIncidents {
  serviceId?: number;
  maximumIncidentsQuantity?: number;
  unlimited?: boolean;
}

export interface ServiceAutomaticClose {
  serviceId: number;
  automaticTransitions?:
    | ServiceAutomaticClosing[]
    | AutomaticTransition[]
    | null;
}

export interface ServiceInterventionCode {
  serviceId?: number;
  ticketStatusId?: number;
  enabled?: boolean;
}

export interface IConfigureServiceRequirement {
  serviceId: number;
  ticketStatusIds: number[];
}

export interface IServiceRequirementConfigs {
  ticketStatusId: number;
  ticketStatusName: string;
  enabled: boolean;
}
export interface ResponseServiceProductAndAutomaticClose {
  serviceId?: number;
  requireServiceProduct?: Require;
  requireServiceSupply?: Require;
  requireInterventionCode?: Require;
  serviceAutomaticTransition?: ServiceAutomaticTransition[];
  serviceStatusFlow?: ServiceStatusFlow;
  serviceAutomaticClose?: ServiceAutomaticTransition;
  serviceRequirementConfigs?: IServiceRequirementConfigs[];
}

export interface Require {
  ticketStatusId?: number;
  ticketStatusName?: string;
  enabled?: boolean;
  amount?: number;
}

export interface ServiceAutomaticTransition {
  transitionId?: number;
  typeId?: number;
  typeName?: string;
  originStatusId?: number;
  originStatusName?: string;
  finalStatusId?: number;
  finalStatusName?: string;
  days?: number;
  hours?: number;
  enabled?: boolean;
}

export interface ServiceStatusFlow {
  lastStatusId?: number;
  lastStatusName?: string;
  assignationStatusId?: number;
  assignationStatusName?: string;
  cancellationReasonStatusId?: null;
  cancellationReasonStatusName?: null;
  interventionCodeStatusId?: null;
  interventionCodeStatusName?: null;
  rejectionStatusId?: null;
  rejectionStatusName?: null;
  pendingReasonStatusId?: null;
  pendingReasonStatusName?: null;
  sendSurvey?: null;
  productStatusId?: number;
  productStatusName?: string;
  supplyStatusId?: number;
  supplyStatusName?: string;
  internalRejectionStatusId?: number;
  clientRejectionStatusId?: number;
}

export interface ResponseLimitingValuesService {
  key: string;
  value: number | string;
}

export interface WorkFlowOrder {
  additionalInfo: string;
  id: number;
  name: string;
  description: string;
  key: string;
  createdDate: Date | null;
  closedDate: Date | null;
  cancelledDate: Date | null;
  workFlowId: number;
  workFlowName: string;
  estate: string;
  estateId: number;
  clientId: number;
  clientName: string;
  locationId: number;
  locationName: string;
  locationDescription: string;
  projectName: string;
  partnerIds: number[];
  enabled: boolean;
}

export interface WorkFlowOrderComment {
  ticketId: number;
  ticketCommentId: number;
  ticketCommentTypeId: number;
  ticketCommentTypeName: string;
  comment: string;
  createdUserId: number;
  createdUserName: string;
  createdDate: string;
}

export interface WorkFlowOrderDocument {
  ticketId: number;
  ticketFileId: number;
  ticketFileName: string;
  ticketFileDescription: string;
  blobStorageUrlPath: string;
  createdUserId: number;
  createdUserName: string;
  createdDate: string;
}

export interface CreateWorkFlowOrderPayload {
  description: string;
  workFlowId: number;
  locationId: number;
}

export interface CreateWorkFlowOrderResponse {
  workFlowOrderId: number;
  workFlowOrderKey: string;
  ticketId: number;
}

export interface CancelWorkFlowOrderRequest {
  workFlowOrderId?: number;
  comment?: string;
  reasonId: number;
}

export interface SaveServicePayload {
  clientId: number;
  name: string;
  description: string;
  currencyId: number;
  paymentTypeId: number;
  serviceTypeId: number;
}

export interface DeleteODTResponse {
  message?: string;
  closedTickets?: null;
  noClosedTickets?: null;
}

export interface DeleteRelatedStages {
  workFlowStageId: number;
  relatedStageIds: number[];
}

export interface PatchWorkFlowStageOrdersList {
  workFlowStageOrdersLists?: {
    stageId?: number;
    isInitial?: boolean;
    isFinal?: boolean;
  }[];
}

export interface WorkFlowOrderByLocationResponse {
  id?: number;
  description?: string;
  key?: string;
  createdDate?: Date;
  closedDate?: Date;
  cancelledDate?: null;
  workFlowId?: number;
  workFlowName?: string;
  estateId?: number;
  estate?: string;
  clientId?: number;
  clientName?: string;
  projectId?: number;
  projectName?: string;
  locationId?: number;
  locationName?: string;
  locationDescription?: string;
  additionalInfo?: null;
  enabled?: boolean;
  partnerName?: null;
  partnerId?: number;
}

export interface GetGanttDiagramResponse {
  id: number;
  workflowOrderName: string;
  initialStepTicket: StepTicket;
  initialStepService: StepService;
  misconfiguredServices: StepService[];
}

export interface StepTicket {
  stepName: string;
  serviceId: number;
  serviceName: string;
  ticketId: number;
  ticketStatusId: number;
  progress: number;
  serviceResponseTime: number;
  assignedEngineer: string;
  stepTicket: StepTicket[];
  ticketClientGroup: string;
}

export interface StepService {
  workFlowName: string;
  stepName: string;
  serviceId: number;
  serviceName: string;
  message?: string;
  stepServices: StepService[];
  stepTicket: StepTicket;
}

export interface TicketFlowGraph {
  ticketStatusId: number;
  name: string;
  relatedStatus: TicketFlowGraph[];
}

export interface GetGanttResponse {
  initialStatus: TicketFlowGraph;
  allStatuses: TicketFlowGraph[];
}

export interface CreateWaterMarkRequest {
  clientId?: number;
  fields?: string;
  fontSize?: string;
  fontColor?: string;
  backgroundColor?: string;
  text?: string;
  lineBreak?: boolean;
}
export interface AutomaticTransition {
  transitionId?: number;
  typeId?: number;
  typeName?: string;
  originStatusId?: number;
  originStatusName?: string;
  finalStatusId?: number;
  finalStatusName?: string;
  days?: number;
  hours?: number;
  enabled?: boolean;
}

export interface GetWaterMarkResponse {
  id: number;
  clientName: string;
  watermark: {
    fields?: string;
    fieldsTranslated?: string;
    fontSize?: string;
    fontColor?: string;
    backgroundColor?: string;
    text?: string;
    lineBreak?: boolean;
  };
}

export interface StatusByClient {
  categoryId: number;
  categoryName: string;
  ticketStatuses: {
    ticketStatusId: number;
    name: string;
    description: string;
    hexColor: string;
    base: boolean;
  }[];
}

export interface ConfigureServiceFlowStatesRequest {
  serviceId?: number;
  lastStatusId?: number;
  assignationStatusId?: number;
  cancellationReasonStatusId?: number;
  interventionCodeStatusId?: number;
  rejectionStatusId?: number;
  pendingReasonStatusId?: number;
  sendSurvey?: boolean;
  internalRejectionStatusId?: number;
  clientRejectionStatusId?: number;
  ticketProductStatusId?: number;
}

export interface GetServiceConfigurationsResponse {
  lastStatusId: number;
  lastStatusName: string;
  assignationStatusId: number;
  assignationStatusName: string;
  cancellationReasonStatusId: number;
  cancellationReasonStatusName: string;
  interventionCodeStatusId: number;
  interventionCodeStatusName: string;
  rejectionStatusId: number;
  rejectionStatusName: string;
  pendingReasonStatusId: number;
  pendingReasonStatusName: string;
  sendSurvey: boolean;
}

export interface ServiceProductAndAutomaticClose {
  serviceId: number;
  automaticTransitions?: ServiceAutomaticClosing | AutomaticTransition;
  serviceProduct?: ServiceProduct;
  originStatusId?: number;
}

/* API */
export default {
  instance,
  adminClients: {
    /**
     * No description
     *
     * @tags AdminClients
     * @name detail
     * @request POST:/api/v1/AdminClients/{id}
     * @secure
     */
    detail: (projectId: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<AdminClientDetail>>({
        url: `/AdminClients/${projectId}`,
        method: 'POST',
        ...config
      })
  },
  clients: {
    /**
     * TRAE TODOS LOS CLIENTES HABILITADOS SIN PAGINAR
     *
     * @tags Clients
     * @name List
     * @request GET:/api/v1/Clients/EnabledClients
     * @secure
     */
    getAllEnabledClients: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<Client[]>>({
        url: `/Clients/EnabledClients`,
        method: 'GET',
        ...config
      }),

    /**
     * TRAE TODOS LOS CLIENTES SIN PAGINAR
     *
     * @tags Clients
     * @name List
     * @request GET:/api/v1/Clients
     * @secure
     */
    list: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<Client[]>>({
        url: `/Clients`,
        method: 'GET',
        ...config
      }),

    /**
     * No description
     *
     * @tags Clients
     * @name Detail
     * @request GET:/api/v1/Clients/{id}
     * @secure
     */
    detail: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<Client>>({
        url: `/Clients/${id}`,
        method: 'GET',
        ...config
      }),

    /**
     * TRAE LOS TIPOS DE SERVICIOS RELACIONADO A UN CLIENTE
     *
     * @tags Clients
     * @name serviceTypesDetail
     * @request GET: /api/v1/ServiceTypes
     * @secure
     */
    serviceTypesDetail: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ClientJobCategory[]>>({
        url: `/ServiceTypes`,
        method: 'GET',
        ...config
      }),

    /**
     * TRAE TODOS LOS NOMBRE DEL SERVICIO ASOCICADOS AL CLIENTE Y AL TIPO DE SERVICIO
     *
     * @tags Clients
     * @name ServiceTypeAndServiceDetail
     * @request GET: /api/v1/Clients/{client id}/ServiceTypes/{serviceTypeId}/Services
     * @secure
     */
    ServiceTypeAndServiceDetail: (
      id: number,
      serviceTypeId: number,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<ClientJobSubCategory[]>>({
        url: `/Clients/${id}/ServiceTypes/${serviceTypeId}/Services`,
        method: 'GET',
        ...config
      }),

    /**
     * TRAE LOS DETALLES DE LA UBICACION
     *
     * @tags Clients
     * @name locationDetail
     * @request GET:/api/v1/Clients/{id}/Location/{locationName}
     * @secure
     */
    locationDetail: (
      id: number,
      locationName: string,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<ClientLocationDetail>>({
        url: `/Clients/${id}/Location/${locationName}`,
        method: 'GET',
        ...config
      }),

    /**
     * No description
     *
     * @tags Clients
     * @name locationsDetail
     * @request GET:/api/v1/Clients/{id}/Locations
     * @secure
     */
    locationsDetail: (id: number | string, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ClientLocationItem[]>>({
        url: `/Clients/${id}/Locations`,
        method: 'GET',
        ...config
      }),

    /**
     * TRAE TODOS LOS SERVICIOS ASOCIADOS AL ID DEL CLIENTE
     *
     * @tags Clients
     * @name servicesDetail
     * @request GET:/api/v1/Clients/{id}/Services
     * @secure
     */
    servicesDetail: (
      id: number | string,
      ignoreIncidentType: boolean = null,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<ClientService[]>>({
        url: `/Clients/${id}/Services`,
        method: 'GET',
        params: {
          ignoreIncidentType
        },
        ...config
      }),
    /**
     * GET PARA TRAER TODOS LOS CLIENTES
     *
     * @tags Clients
     * @name getAllClient
     * @request GET :/api/v1/Clients
     * @secure
     */
    getAllClientSinPaginar: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<GetAllClientWithoutPag[]>>({
        url: `/Clients`,
        method: 'GET',
        ...config
      }),
    /**
     * POST PARA TRAER TODOS LOS CLIENTES
     *
     * @tags Clients
     * @name getAllClient
     * @request POST :/api/v1/Clients/GeneralSearch
     * @secure
     */
    getAllClient: (data: AllClientRequest, config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<AllClientResponse>>
      >({
        url: `/Clients/GeneralSearch`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * POST PARA TRAER TODOS LOS CLIENTES
     *
     * @tags Clients
     * @name getClientById
     * @request GET :/api/v1/Clients/{id}
     * @secure
     */
    getClientById: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<GetClientsInfoByID>>({
        url: `/Clients/${id}`,
        method: 'GET',
        ...config
      }),
    /**
     * DELTE PARA LOS CLIENTES POR ID
     *
     * @tags Clients
     * @name deleteClients
     * @request DELETE : api/v1/Clients
     * @secure
     */
    deleteClients: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, any>({
        url: `/Clients/${id}`,
        method: 'DELETE',
        ...config
      }),
    /**
     * CREATE DE CLIENTES
     *
     * @tags Clients
     * @name createClients
     * @request POST:/api/v1/Clients
     * @secure
     */
    createClients: (
      data: CreateClientRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, any>({
        url: `/Clients`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * EDIT DE CLIENTES
     *
     * @tags Clients
     * @name editClients
     * @request PUT : api/v1/Clients
     * @secure
     */
    editClients: (data: EditClientsInfo, config: AxiosRequestConfig = {}) =>
      instance.request<void>({
        url: `/Clients`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * Prioridades de clientes
     * @tags Clients
     * ClientPrioritiesByClient
     * @request GET:/api/v1/Clients/ClientPrioritiesByClient
     * @secure
     */
    ClientPrioritiesByClient: (
      params: ClientPrioritiesByClientRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<ClientPrioritiesByClient>>
      >({
        url: `/Clients/ClientPrioritiesByClient`,
        method: 'GET',
        params,
        paramsSerializer: () =>
          qs.stringify(params, {
            arrayFormat: 'repeat'
          }),
        ...config
      }),
    /**
     * Tipos de servicio asociados al cliente
     * @tags Clients
     * @name getClientServiceTypesByClient
     * @request GET:/api/v1/Clients/ClientServiceTypes/{clientId}
     * @secure
     */
    getClientServiceTypesByClient: (
      clientId: number,
      params?: {
        forTicket?: boolean;
        forRelatedTask?: boolean;
        isTowerService?: boolean;
      },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<ServiceTypeListItem[]>>({
        url: `/Clients/ClientServiceTypes/${clientId}`,
        params,
        paramsSerializer: () =>
          qs.stringify(params, {
            arrayFormat: 'repeat'
          }),
        method: 'GET',
        ...config
      }),
    /**
     * Asignar tipos de servicio a un cliente
     * @tags Clients
     * @name assignClientServiceTypes
     * @request POST:/api/v1/Clients/AssignClientServiceType
     * @secure
     */
    assignClientServiceTypes: (
      data: AssignClientServiceTypesRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<void>>({
        url: `/Clients/AssignClientServiceType`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * Obtiene los estados de tickets activos por cliente
     * @tags Clients
     * @name GetAllStatusesByClient
     * @request GET:/api/v1/Clients/GetAllStatusesByClient
     * @secure
     */
    getAllStatusesByClient: (
      params: {
        clientId: number;
        serviceTypeId: number;
        exceptFinished: boolean;
      },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<StatusByClient[]>>({
        url: `/Clients/GetAllStatusesByClient`,
        method: 'GET',
        params,
        paramsSerializer: (p) => qs.stringify(p, { arrayFormat: 'repeat' }),
        ...config
      }),
    /**
     * Obtiene los estados de tickets activos por cliente
     * @tags Clients
     * @name getActiveStatusesByClient
     * @request GET:/api/v1/Clients/GetActiveStatusesByClient
     * @secure
     */
    getActiveStatusesByClient: (
      params: { clientId: number; serviceTypeId: number },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<StatusByClient[]>>({
        url: `/Clients/GetActiveStatusesByClient`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * Obtiene los estados de tickets finalizados por cliente
     * @tags Clients
     * @name getActiveStatusesByClient
     * @request GET:/api/v1/Clients/GetFinishedStatusesByClient
     * @secure
     */
    getFinishedStatusesByClient: (
      params: { clientId: number; serviceTypeId: number },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<StatusByClient[]>>({
        url: `/Clients/GetFinishedStatusesByClient`,
        method: 'GET',
        params,
        ...config
      })
  },
  services: {
    /**
     * TRAE LOS DETALLES DEL SERVICIO
     *
     * @fase 2
     * @tags Projects
     * @name detail
     * @request GET:/api/v1/Services/{id}
     * @secure
     */
    detail: (serviceId: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ServiceDetail>>({
        url: `/Services/${serviceId}`,
        method: 'GET',
        ...config
      }),
    /**
     * POST PARA GUARDAR LOS SERVICIO PARA EL CLIENTE
     *
     * @fase 2
     * @tags SaveService
     * @name SaveService
     * @request POST:/api/v1/Services/SaveService
     * @secure
     */
    SaveService: (data: UpdateService, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/Services/SaveService`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * TRAE TODOS LOS SERVICIOS PARA EL CLIENTE PAGINADOS
     *
     * @fase 2
     * @tags ServiceSearch
     * @name ServiceSearch
     * @request POST:/api/v1/Services/ServiceSearch
     * @secure
     */
    generalClientServiceSearch: (data: any, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<PagedList<Service>>>({
        url: `/Services/ServiceSearch`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * ELIMINACION MASIVA DE SERVICIOS
     *
     * @fase 2
     * @tags ServiceSearch
     * @name ServiceSearch
     * @request DELETE: /api/v1/Services
     * @secure
     */
    deleteMassiveServices: (
      data: { ids: number[] },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<{
          successDeleted?: string;
          failureOnDelete?: null;
        }>
      >({
        url: `/Services`,
        method: 'DELETE',
        data,
        ...config
      }),

    /**
     * TRAE TODOS LOS SERVICIOS PAGINADOS
     *
     * @fase 1
     * @tags Services
     * @name generalSearch
     * @request POST:/api/v1/Services
     * @secure
     */
    generalSearch: (
      data: ServiceSearchRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PagedList<Service>>>({
        url: `/Services`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * POST PARA CONFIGURAR LOS DATOS DEL CLIENTE
     *
     * @fase 2
     * @tags Services
     * @name configure
     * @request POST:/api/v1/Services/ConfigureService
     * @secure
     */
    configure: (
      data: ConfigureServiceRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<ServiceConfigured>>({
        url: `/Services/ConfigureService`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * ES EL POST JORNADA LABORAL
     *
     * @fase 1
     * @tags Services
     * @name jobSchedule
     * @request POST:/api/v1/Services/ConfigureJobSchedule
     * @secure
     */
    jobSchedule: (
      data: ConfigureJobScheduleRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<ConfigureJobScheduleRequest>>(
        {
          url: `/Services/ConfigureJobSchedule`,
          method: 'POST',
          data,
          ...config
        }
      ),
    /**
     * POST PARA CONFIGURAR LOS DIAS DE ATENCION DEL CLIENTE
     *
     * @fase 1
     * @tags Services
     * @name ConfigureServiceSchedule
     * @request POST:/api/v1/Services/ConfigureServiceSchedule
     * @secure
     */
    ConfigureServiceSchedule: (
      data: GetAttentionTimeRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<GetAttentionTimeRequest>>({
        url: `/Services/ConfigureServiceSchedule`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * GET PARA TRAER LOS DIAS DE ATENCION DEL CLIENTE
     *
     * @fase 1
     * @tags Project
     * @name serviceSchedule
     * @request GET:/api/v1/Services/${id}/ServiceSchedule
     * @secure
     */
    serviceSchedule: (serviceId: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<GetAttentionTimeResponse[]>>({
        url: `/Services/${serviceId}/ServiceSchedule`,
        method: 'GET',
        ...config
      }),
    /**
     * Obtiene las configuraciones del proyecto enviado
     *
     * @fase 1
     * @tags serviceConfigs
     * @name services
     * @request GET:/api/v1/Services/{id}/ServiceConfigs
     * @secure
     */
    serviceConfigs: (serviceId: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ServiceConfigMinEvidence[]>>({
        url: `/Services/${serviceId}/ServiceConfigs`,
        method: 'GET',
        ...config
      }),
    /**
     * POST PARA CONFIGURAR LAS EVIDENCIAS MINIMAS A ENVIAR
     *
     * @fase 1
     * @tags Project
     * @name MinimalEvidenceRequest
     * @request POST:/api/v1/Services/ConfigureServiceMinimumEvidence
     * @secure
     */
    minimalEvidenceRequest: (
      data: MinimalEvidenceRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<MinimalEvidenceRequest>>({
        url: `/Services/ConfigureServiceMinimumEvidence`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * POST PARA CONFIGURAR EL COMPONENTE DE CONFIGURACION
     *
     * @fase 1
     * @tags Project
     * @name configComponentRequest
     * @request POST:/api/v1/Services/ConfigureServiceOperationType
     * @secure
     */
    configComponentRequest: (
      data: OperationTypeRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<OperationTypeRequest>>({
        url: `/Services/ConfigureServiceOperationType`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     *
     * @fase 2
     * @tags Services
     * @name ConfigureIndicatorStates
     * @request POST: /api/v1/Config/ConfigureIndicatorStates
     * @secure
     */
    configureIndicatorStates: (
      data: ConfigureIndicatorStatesRequest[],
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<ConfigureIndicatorStatesRequest>
      >({
        url: `Config/ConfigureIndicatorStates`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     *
     * @fase 2
     * @tags Services
     * @name IndicatorStates
     * @request GET: api/v1/Config/IndicatorStates
     * @secure
     */
    indicatorStates: (config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<ConfigureIndicatorStatesRequest[]>
      >({
        url: `Config/IndicatorStates`,
        method: 'get',
        ...config
      }),

    /**
     * No description
     *
     * @fase 2
     * @tags Service
     * @name serviceSearch
     * @request POST:/api/v1/Services/ServiceSearch
     * @secure
     */
    serviceSearch: (
      serviceParams: ServiceSearchParams,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<ServiceSearchResponse[]>>
      >({
        url: `/Services/ServiceSearch`,
        method: 'POST',
        data: serviceParams,
        ...config
      }),
    /**
     * No description
     *
     * @fase 2
     * @tags Services
     * @name deleteService
     * @request DELETE:/api/v1/Services/{id}
     * @secure
     */
    deleteService: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<DeleteServiceResponse>>({
        url: `/Services/${id}`,
        method: 'DELETE',
        ...config
      }),
    /**
     * No description
     *
     * @fase 2
     * @tags Services
     * @name saveService
     * @request POST:/api/v1/Services/SaveProject
     * @secure
     */
    saveService: (
      serviceParams: SaveServiceParams,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<SaveServiceResponse>>({
        url: `/Services/SaveService`,
        method: 'POST',
        data: serviceParams,
        ...config
      }),
    /**
     * No description
     *
     * @fase 2
     * @tags Service
     * @name getServiceById
     * @request GET:/api/v1/Services/{id}
     * @secure
     */
    getServiceById: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ServiceDetail>>({
        url: `/Services/${id}`,
        method: 'GET',
        ...config
      }),
    /**
     * No description
     *
     * @fase 2
     * @tags Services
     * @name updateServiceById
     * @request PUT:/api/v1/Services/UpdateService/{id}
     * @secure
     */
    updateServiceById: (
      serviceData: {
        id: number;
        data: SaveServiceParams;
      },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<DeleteServiceResponse>>({
        url: `/Services/UpdateServices/${serviceData.id}`,
        method: 'PUT',
        data: serviceData.data,
        ...config
      }),
    /**
     * ACTUALIZA EL SERVICIO RELACIONADO A UN CLIENTE
     *
     * @fase 2
     * @tags Services
     * @name updateService
     * @request PUT:/api/v1/Services/UpdateService
     * @secure
     */
    updateService: (data?: UpdateService, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Services/UpdateService`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * ELIMINACION MASIVA DE SERVICIOS
     *
     * @fase 2
     * @tags Services
     * @name massiveDeleteServices
     * @request DELETE: /v1/Services?serviceIds=id
     * @secure
     */
    massiveDeleteServices: (data: string, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<DeleteServiceResponse>>({
        url: `/Services?${data}`,
        method: 'DELETE',
        ...config
      }),
    /**
     * TRAE LOS SLA DE UN SERVICIO RELACIONADO A UN CLIENTE
     *
     * @fase 2
     * @tags Services
     * @name GetServiceResponseTime
     * @request GET: /ServiceResponseTimes/Service/${id}
     * @secure
     */
    GetServiceResponseTime: (
      id: number,
      params?: IParamsFilter,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<IServiceResponseTimes[]>>
      >({
        url: `/ServiceResponseTimes/Service/${id}`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * CREA LOS SLA DE UN SERVICIO RELACIONADO A UN CLIENTE
     *
     * @fase 2
     * @tags Services
     * @name CreateServiceResponseTime
     * @request POST: /ServiceResponseTimes
     * @secure
     */
    CreateServiceResponseTime: (
      data: CreateServiceResponseTimes,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/ServiceResponseTimes`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * ACTUALIZA LOS SLA DE UN SERVICIO RELACIONADO A UN CLIENTE
     *
     * @fase 2
     * @tags Services
     * @Updatee UpdateServiceResponseTime
     * @request PUT: /ServiceResponseTimes
     * @secure
     */
    UpdateServiceResponseTime: (
      data: UpdateServiceResponseTimes,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/ServiceResponseTimes`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * ELIMINA LOS SLA DE UN SERVICIO RELACIONADO A UN CLIENTE
     *
     * @fase 2
     * @tags Services
     * @Updatee DeleteServiceResponseTime
     * @request DELETE: /ServiceResponseTimes/${id}
     * @secure
     */
    DeleteServiceResponseTime: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/ServiceResponseTimes/${id}`,
        method: 'DELETE',
        ...config
      }),
    /**
     *
     * @fase 2
     * @tags Services
     * @name GetServiceConfigs
     * @request GET: /ServiceConfigurations/Service/${id}/Configs
     * @secure
     */
    GetServiceConfigs: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<ResponseServiceProductAndAutomaticClose>
      >({
        url: `/ServiceConfigurations/Service/${id}/Configs`,
        method: 'GET',
        ...config
      }),
    /**
     *
     * @fase 2
     * @tags Services
     * @name GetLimitingValuesService
     * @request GET: /ServiceConfigurations/Service/${id}
     * @secure
     */
    GetLimitingValuesService: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<ResponseLimitingValuesService[]>
      >({
        url: `/ServiceConfigurations/Service/${id}`,
        method: 'GET',
        ...config
      }),

    /**
     *
     * @fase 2
     * @tags Services
     * @name ConfigureService
     * @request POST: /ServiceConfigurations/ConfigureServiceProductAndAutomaticTransition
     * @secure
     */
    ConfigureService: (
      data: ServiceProductAndAutomaticClose,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/ServiceConfigurations/ConfigureServiceProductAndAutomaticTransition`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     *
     * @fase 2
     * @tags Services
     * @name ConfigureServiceMaximumIncidents
     * @request POST: /ServiceConfigurations/ConfigureServiceMaximumIncidents
     * @secure
     */
    ConfigureServiceMaximumIncidents: (
      data: ServiceMaximunIncidents,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<ServiceConfigured>>({
        url: `/ServiceConfigurations/ConfigureServiceMaximumIncidents`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     *
     * @fase 2
     * @tags Services
     * @name ConfigureServiceAutomaticClose
     * @request POST: /ServiceConfigurations/ConfigureServiceAutomaticClose
     * @secure
     */
    ConfigureServiceAutomaticClose: (
      data: ServiceAutomaticClose,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<ServiceConfigured>>({
        url: `/ServiceConfigurations/ConfigureServiceAutomaticClose`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     *
     * @fase 2
     * @tags Services
     * @name ConfigureServiceProduct
     * @request POST: /ServiceConfigurations/ConfigureServiceProduct
     * @secure
     */
    ConfigureServiceProduct: (
      data: ServiceProduct,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<ServiceConfigured>>({
        url: `/ServiceConfigurations/ConfigureServiceProduct`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     *
     * @fase 2
     * @tags Services
     * @name ConfigureServiceInterventionCode
     * @request POST: /ServiceConfigurations/ConfigureServiceInterventionCode
     * @secure
     */
    ConfigureServiceInterventionCode: (
      data: ServiceInterventionCode,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<ServiceConfigured>>({
        url: `/ServiceConfigurations/ConfigureServiceInterventionCode`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     *
     * @fase 2
     * @tags Services
     * @name GetServiceSupplies
     * @request POST: /api/v1/ServiceConfigurations/Service/Supplies
     * @secure
     * @description Obtiene los insumos por servicio
     */
    GetServiceSupplies: (
      data: ServiceSupplyPayload,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PagedList<ServiceSupply>>>({
        url: `/ServiceConfigurations`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     *
     * @fase 2
     * @tags Services
     * @name ConfigureServiceSupplies
     * @request POST: /api/v1/ServiceConfigurations/ConfigureServiceSupplies
     * @secure
     * @description Configura los insumos que va a permitir instalar el servicio
     */
    ConfigureServiceSupplies: (
      data: ConfigureServiceSuppliesPayload,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<void>>({
        url: `/ServiceConfigurations/ConfigureServiceSupplies`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Obtiene el Flujo de tickets asignado al Servicio
     *
     * @tags Services
     * @name getTicketFlow
     * @request GET:/client/api/v1/Services/{id}/TicketFlow
     * @secure
     */
    getTicketFlow: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<[]>>({
        url: `/Services/${id}/TicketFlow`,
        method: 'GET',
        ...config
      })
  },
  project: {
    /**
     * No description
     *
     * @tags Project
     * @name getProjects
     * @request GET:/api/v1/Project
     * @secure
     */
    getProjects: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<IProjectResponse[]>>({
        url: `/Project`,
        method: 'GET',
        ...config
      })
  },
  responsables: {
    /**
     * ES EL GET PARA TRAER TODOS LOS INGENIEROS
     *
     * @tags AdminClients
     * @name GetAllEnginersForAPostCode
     * @request GET:client/api/v1/Responsibles
     * @secure
     */
    GetAllEnginersForAPostCode: (
      params: {
        text?: string;
        orderColumn?: string;
        descending?: boolean;
        pageSize?: number;
        pageNumber?: number;
      },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<ResponsiblesResponse>>
      >({
        url: `/Responsibles`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * ES EL POST DE ZONAS LABORALES
     *
     * @tags AdminClients
     * @name ConfigureWorkZonesRequest
     * @request POST:/api/v1/Responsibles/ConfigureWorkZones
     * @secure
     */
    ConfigureWorkZonesRequest: (
      data: ConfigureWorkZonesRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<ConfigureWorkZonesRequest>>({
        url: `Responsibles/ConfigureWorkZones`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * ES EL GET PARA TRAER TODOS LOS INGENIEROS POR TIPO DE RESPONSABLE
     * @tags Responsibles
     * @name getResponsibleByResponsibleType
     * @request GET:client/api/v1/Responsibles/ResponsibleByResponsibleType
     * @secure
     */
    getResponsibleByResponsibleType: (
      params: { responsibleTypeId: number; All?: boolean; clientId?: number },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<Responsible[]>>({
        url: `/Responsibles/ResponsibleByResponsibleType`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * GET PARA TRAER RESPONSIBLES DE ALMACEN
     * @tags Responsibles
     * @name getWarehouseResponsibles
     * @request GET:client/api/v1/Responsibles/WarehouseResponsible
     * @secure
     */
    getWarehouseResponsibles: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<Responsible[]>>({
        url: `/Responsibles/WarehouseResponsible`,
        method: 'GET',
        ...config
      }),

    /**
     * GET PARA ALMACENES
     * @tags ALMACENS
     * @name getResponsibleByResponsibleTypeOne
     * @request GET:client/api/v1/Responsibles/ResponsibleByResponsibleType?ResponsibleTypeId=1
     * @secure
     */
    getResponsibleByResponsibleTypeOne: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<Responsible[]>>({
        url: `/Responsibles/ResponsibleByResponsibleType?ResponsibleTypeId=1`,
        method: 'GET',
        ...config
      })
  },
  workFlow: {
    /**
     * ES EL POST DE WORK FLOW
     *
     * @tags WorkFlow
     * @name ConfigureWorkFlow
     * @request POST: /client/api/v1/WorkFlow
     * @secure
     */
    ConfigureWorkFlow: (
      data: WorkFlowRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<WorkFlowResponse>>({
        url: `/WorkFlow`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * ES EL GET DE WORK FLOW POR ID DE SERVICIO
     *
     * @tags WorkFlow
     * @name GetWorkFlow
     * @request GET: /client/api/v1/WorkFlow
     * @secure
     */
    GetWorkFlow: (serviceId: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<GetWorkFLowResponse>>({
        url: `/WorkFlow?serviceId=${serviceId}`,
        method: 'GET',
        ...config
      }),

    /**
     * Obtener WorkFlows por WorkFlowTypeId enviando en los parámetros
     *
     * @tags WorkFlow
     * @name GetWorkFlowsByWorkFlowTypeId
     * @request GET: /api/v1/WorkFlows
     * @secure
     */
    getWorkFlowsByWorkFlowTypeId: (
      params: { workFlowTypeId: number | string },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<WorkFlowItem[]>>({
        url: `/WorkFlows`,
        method: 'GET',
        params,
        ...config
      }),

    /**
     * General Search de Workflow
     * @tags WorkFlow
     * @name GeneralSearch
     * @request GET:/api/v1/WorkFlows/GeneralSearch
     * @secure
     */
    GeneralSearch: (
      params: GeneralSearchRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PagedList<WorkFlowItem>>>({
        url: `/WorkFlows/GeneralSearch`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * Crear Workflow
     * @tags WorkFlow
     * @name CreateWorkFlow
     * @request POST:/api/v1/WorkFlows
     */
    CreateWorkFlow: (
      data: CreateWorkFlowRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/WorkFlows`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Update Workflow
     * @tags WorkFlow
     * @name UpdateWorkFlow
     * @request PUT:/api/v1/WorkFlows
     * @secure
     */
    UpdateWorkFlow: (
      data: UpdateWorkFlowRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/WorkFlows`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * Eliminar Workflow
     * @tags WorkFlow
     * @name DeleteWorkFlow
     * @request DELETE:/api/v1/WorkFlows/{id}
     * @secure
     */
    DeleteWorkFlow: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/WorkFlows/${id}`,
        method: 'DELETE',
        ...config
      })
  },
  countryStates: {
    /**
     * Obtener estados por cliente
     * @tags CountryStates
     * @name GetStatesByClient
     * @request GET:/api/v1/CountryStates/GetStatesByClient
     * @secure
     */
    GetStatesByClient: (
      params: CountryStatesByClientRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<CountryStatesByClient>>
      >({
        url: `/CountryStates/byClient`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * Editar estados por cliente
     * @tags CountryStates
     * @name UpdateStatesByClient
     * @request PUT:/api/v1/CountryStates/UpdateStatesByClient
     * @secure
     */
    UpdateStatesByClient: (
      data: UpdateStatesByClientRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<UpdateStatesByClientResponse>
      >({
        url: `/CountryStates/UpdateStatesByClient`,
        method: 'PUT',
        data,
        ...config
      })
  },
  serviceTypes: {
    /**
     * Obtener tipos de servicio
     * @tags ServiceTypes
     * @name GetServiceTypes
     * @request GET:/api/v1/ServiceTypes
     * @secure
     */
    GetServiceTypes: (config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<ServiceType[]>>({
        url: `/ServiceTypes`,
        method: 'GET',
        ...config
      })
  },
  workFlows: {
    /**
     * @tags ClientWorkFlows
     * @name GetAllWorkFlowsByClientID
     * @request POST:/api/v1/WorkFlows/Client/${clientID}/GetAll
     * @secure
     */
    GetAllWorkFlowsByClientID: (
      clientID: number,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<WorkFlow[]>>({
        url: `/WorkFlows/Client/${clientID}/GetAll`,
        method: 'GET',
        ...config
      })
  },
  workFlowStages: {
    /**
     * @tags CatalogWorkFlowStages
     * @name GeneralSearch
     * @request GET:/api/v1/WorkFlowStages/GeneralSearch
     * @secure
     */
    GeneralSearch: (params: IParamsFilter, config: AxiosRequestConfig = {}) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<WorkFlowStagesItem>>
      >({
        url: `/WorkFlowStages/GeneralSearch`,
        method: 'GET',
        params,
        ...config
      }),
    /**
     * @tags CatalogWorkFlowStages
     * @name CreateWorkFlowStages
     * @request POST:/api/v1/WorkFlowStages
     * @secure
     */
    CreateWorkFlowStages: (
      data: CreateWorkFlowStages,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/WorkFlowStages`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * @tags CatalogWorkFlowStages
     * @name EditWorkFlowStages
     * @request PUT:/api/v1/WorkFlowStages
     * @secure
     */
    EditWorkFlowStages: (
      data: EditWorkFlowStages,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/WorkFlowStages`,
        method: 'PUT',
        data,
        ...config
      }),
    /**
     * @tags CatalogWorkFlowStages
     * @name DeleteWorkFlowStages
     * @request DELETE:/api/v1/WorkFlowStages
     * @secure
     */
    DeleteWorkFlowStages: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/WorkFlowStages/${id}`,
        method: 'DELETE',
        ...config
      }),
    /**
     * @tags CatalogWorkFlowStages
     * @name DeleteRelatedStages
     * @request DELETE:/api/v1/WorkFlowStages/DeleteRelatedStages
     * @secure
     */
    DeleteRelatedStages: (
      data: DeleteRelatedStages,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `WorkFlowStages/DeleteRelatedStages`,
        method: 'DELETE',
        data,
        ...config
      }),
    /**
     * ENDPOINT PARA ACTUALIZAR UNICAMENTE SI ES ETAPA INICIAL O FINAL
     * @tags CatalogWorkFlowStages
     * @name PatchInitialOrEndStage
     * @request PATCH:/api/v1/WorkFlowStages
     * @secure
     */
    PatchInitialOrEndStage: (
      data: PatchWorkFlowStageOrdersList,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `WorkFlowStages`,
        method: 'PATCH',
        data,
        ...config
      })
  },
  ticketFlow: {
    /**
     * @tags TicketFlow
     * @name GetAllTicketFlow
     * @request GET:/client/api/v1/TicketFlow
     * @secure
     */
    GetAllTicketFlow: () =>
      instance.request<void, AxiosServiceResponse<TicketFlowItem[]>>({
        url: `/TicketFlow`,
        method: 'GET'
      }),
    /**
     * @tags TicketFlow
     * @name GeneralSearch
     * @request POST:/api/v1/TicketFlow/GeneralSearch
     * @secure
     */
    GeneralSearch: (
      params: ParamsTicketFlow,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<PagedList<TicketFlowItem>>>({
        url: `/TicketFlow/GeneralSearch`,
        method: 'GET',
        params,
        ...config
      }),

    /**
     * @tags TicketFlow
     * @name TicketFlowById
     * @request GET:/api/v1/TicketFlow/{id}
     * @secure
     * @description Obtiene un flujo de estatus por ID
     */
    TicketFlowById: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<TicketFlowById>>({
        url: `/TicketFlow/${id}`,
        method: 'GET',
        ...config
      }),

    /**
     * @tags TicketFlow
     * @name GetById
     * @request GET:/api/v1/TicketFlow/GetById
     * @secure
     * @description Obtiene un flujo de estados de Ticket
     */
    GetById: (TicketFlowId: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<TicketFlowById>>({
        url: `/TicketFlow/GetById`,
        method: 'GET',
        params: { TicketFlowId },
        ...config
      }),

    /**
     * @tags TicketFlow
     * @name CreateTicketFlow
     * @request POST:/api/v1/TicketFlow
     * @secure
     * @description Guarda un flujo de estados de Ticket
     */
    CreateTicketFlow: (
      data: CreateTicketFlowPayload,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<{ ticketFlowId: number }>>({
        url: `/TicketFlow`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * @tags TicketFlow
     * @name DeleteTicketFlow
     * @request DELETE:/api/v1/TicketFlow/${id}
     * @secure
     * @description Elimina un flujo de estatus por su ID
     */
    DeleteTicketFlow: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/TicketFlow/${id}`,
        method: 'DELETE',
        ...config
      }),

    /**
     * @tags TicketFlow
     * @name EditTicketFlow
     * @request PUT:/api/v1/TicketFlow/${id}
     * @secure
     * @description Actualiza un flujo de estatus
     */
    EditTicketFlow: (
      data: EditTicketFlowPayload,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/TicketFlow`,
        method: 'PUT',
        data,
        ...config
      }),

    AsociateTicketFlow: (clientID: number, data: AsociateTicketFlowPayload) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `Clients/${clientID}/AsociateTicketFlow`,
        method: 'POST',
        data
      }),

    getGanttDiagram: (id: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<GetGanttResponse>>({
        url: `/TicketFlow/GetGanttDiagram/${id}`,
        method: 'GET',
        ...config
      })
  },
  serviceConfigurations: {
    /**
     * POST PARA CREAR EDITAR UN TIPO DE SERVICIO DE UN CLIENTE
     *
     * @tags service
     * @name SubmitOperationType
     * @request POST: api/v1/ServiceConfigurations/ConfigureServiceOperationType
     * @secure
     */
    SubmitOperationType: (
      data?: OperationTypeRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<any>>({
        url: `/ServiceConfigurations/ConfigureServiceOperationType`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * GET POR ID PARA TRARER LOS TIPO DE SERVICIO DE UN CLIENTE
     *
     * @tags service
     * @name operationTypesById
     * @request GET: api/v1/OperationType/ServiceId/{id}
     * @secure
     */
    operationTypesById: (id?: number, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<OperationType[]>>({
        url: `/OperationType/ServiceId/${id}`,
        method: 'GET',
        ...config
      }),
    /**
     *  Configura la evidencia fotográfica requerida para el servicio
     * @tags ServiceConfigurations
     * @name SubmitOperationType
     * @request POST: /api/v1/ServiceConfigurations/ConfigureServiceEvidences
     * @secure
     */
    ConfigureServiceEvidences: (
      data?: ConfigureServiceEvidencesResquest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<{ serviceId: number; updatedDateTime: Date }>
      >({
        url: `/ServiceConfigurations/ConfigureServiceEvidences`,
        method: 'POST',
        data,
        ...config
      }),

    /**
     * Obtiene la información de evidencias configuradas para el servicio
     *
     * @tags ServiceConfigurations
     * @name GetServiceEvidences
     * @request GET: /api/v1/ServiceConfigurations/GetServiceEvidences
     * @secure
     */
    GetServiceEvidences: (
      params: { serviceId: number },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<ConfigureServiceEvidencesDetail[]>
      >({
        url: `/ServiceConfigurations/GetServiceEvidences`,
        method: 'GET',
        params,
        ...config
      }),

    /**
     * Configura los estados de finalización y asignación para los flujos del servicio
     * @tags ServiceConfigurations
     * @name ConfigureServiceFlowStates
     * @request POST: /api/v1/ServiceConfigurations/ConfigureServiceStatusFlow
     * @secure
     */
    configureServiceFlowStates: (
      data: ConfigureServiceFlowStatesRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/ServiceConfigurations/ConfigureServiceStatusFlow`,
        method: 'POST',
        data,
        ...config
      }),

    /** Obtiene las configuraciones relacionadas al servicio
     * (Cierre automático, requerimiento de componente, requerimiento de Códigos de intervención)
     *  @tags ServiceConfigurations
     * @name getServiceConfigurations
     * @request GET: /api/v1/ServiceConfigurations/Service/${serviceId}/Configs
     * @secure
     */
    getServiceConfigurations: (
      serviceId: number,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<GetServiceConfigurationsResponse>
      >({
        url: `/ServiceConfigurations/Service/${serviceId}/Configs`,
        method: 'GET',
        ...config
      }),
    /**
     *
     * Configura obligatoriedad de evidencias para estatus
     *
     * @tags ServiceConfigurations
     * @name ConfigureServiceRequirement
     * @request POST: /ServiceConfigurations/ConfigureServiceRequirement
     * @secure
     */
    ConfigureServiceRequirement: (
      data: IConfigureServiceRequirement,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<ServiceConfigured>>({
        url: `/ServiceConfigurations/ConfigureServiceRequirement`,
        method: 'POST',
        data,
        ...config
      })
  },
  workFlowOrder: {
    /**
     * Busqueda de ordenes de servicio habilitante
     * @tags workFlowOrder
     * @name GeneralSearch
     * @request GET:/api/v1/WorkFlowOrder/GeneralSearch
     * @secure
     */
    GeneralSearch: (params: IParamsFilter, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<PagedList<WorkFlowOrder>>>({
        url: `/WorkFlowOrder/GeneralSearch`,
        method: 'GET',
        params,
        paramsSerializer: (params) =>
          qs.stringify(params, { arrayFormat: 'repeat' }),
        ...config
      }),

    /**
     * Busqueda de comentarios de orden de servicio por Id
     * @tags workFlowOrder
     * @name getCommentsByID
     * @request GET: /api/v1/WorkFlowOrder/{id}/Comments
     * @secure
     */
    getCommentsByID: (id: number, params: IParamsFilter) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<WorkFlowOrderComment>>
      >({
        url: `/WorkFlowOrder/${id}/comments`,
        method: 'GET',
        params
      }),

    /**
     * Busqueda de archivos de orden de servicio por Id

     * @tags workFlowOrder
     * @name getFilesByID
     * @request GET: /api/v1/WorkFlowOrder/{id}/Files
     * @secure
     */
    getFilesByID: (id: number, params: IParamsFilter) =>
      // TODO: Change type
      instance.request<
        void,
        AxiosServiceResponse<PagedList<WorkFlowOrderDocument>>
      >({
        url: `/WorkFlowOrder/${id}/files`,
        method: 'GET',
        params
      }),

    /**
     * Busqueda de ordenes de servicio por Id
     * @tags workFlowOrder
     * @name findById
     * @request GET: /api/v1/WorkFlowOrder/{id}
     * @secure
     */
    findByID: (id: string) =>
      instance.request<void, AxiosServiceResponse<WorkFlowOrder>>({
        url: `/WorkFlowOrder/${id}`,
        method: 'GET'
      }),

    /**
     * Crear orden de servicio habilitante
     * @tags workFlowOrder
     * @name createWorkFlowOrder
     * @request POST: /api/v1/WorkFlowOrder
     * @secure
     */
    createWorkFlowOrder: (data: CreateWorkFlowOrderPayload) =>
      instance.request<void, AxiosServiceResponse<CreateWorkFlowOrderResponse>>(
        {
          url: `/WorkFlowOrder`,
          method: 'POST',
          data
        }
      ),

    /**
     * Cancelar orden de servicio habilitante
     * @tags workFlowOrder
     * @name cancelWorkFlowOrder
     * @request POST: /api/v1/WorkFlowOrder/CancelWorkFlowOrder
     * @secure
     */
    cancelWorkFlowOrder: (data: CancelWorkFlowOrderRequest) =>
      instance.request<void, AxiosServiceResponse<DeleteODTResponse>>({
        url: `/WorkFlowOrder/CancelWorkFlowOrder`,
        method: 'POST',
        data
      }),

    /**
     * Busca la orden de servicio habilitante por el id de la ubicacion
     * @tags workFlowOrder
     * @name searchWorkFlowOrderByLocationId
     * @request GET: /api/v1/WorkFlowOrder/WorkFlowOrderByLocation
     * @secure
     */
    searchWorkFlowOrderByLocationId: (
      params: IParamsFilter,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<
        void,
        AxiosServiceResponse<PagedList<WorkFlowOrderByLocationResponse>>
      >({
        url: `/WorkFlowOrder/WorkFlowOrderByLocation`,
        method: 'GET',
        params,
        paramsSerializer: (params) =>
          qs.stringify(params, { arrayFormat: 'repeat' }),
        ...config
      }),

    /**
     * Obtención del Diagrama de Gantt según la orden de trabajo
     * @tags workFlowOrder
     * @name getGanttDiagram
     * @request GET: /api/v1/WorkFlowOrder/GetGanttDiagram
     * @secure
     */

    getGanttDiagram: (
      params: {
        workFlowOrderId?: number | string;
        workFlowId?: number;
      },
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<GetGanttDiagramResponse>>({
        url: `/WorkFlowOrder/GetGanttDiagram`,
        method: 'GET',
        params,
        ...config
      })
  },
  waterMark: {
    /**
     * Creacion de la Marca de agua por cliente
     * @tags workFlowOrder
     * @name createWatermark
     * @request POST: /api/v1/Clients/Watermark
     * @secure
     */

    createWatermark: (
      data: CreateWaterMarkRequest,
      config: AxiosRequestConfig = {}
    ) =>
      instance.request<void, AxiosServiceResponse<unknown>>({
        url: `/Clients/Watermark`,
        method: 'POST',
        data,
        ...config
      }),
    /**
     * Obtención de las marcas de agua por id de cliente
     * @tags workFlowOrder
     * @name getWaterMark
     * @request GET: /api/v1/Clients/me/Watermarks?clientId=1
     * @secure
     */

    getWaterMark: (id: string, config: AxiosRequestConfig = {}) =>
      instance.request<void, AxiosServiceResponse<GetWaterMarkResponse[]>>({
        url: `/Clients/me/Watermarks?clientId=${id}`,
        method: 'GET',
        ...config
      })
  }
};
